import useLipaBidhaaStore from "../../../stores/lipaBidhaaStore";
import { Headers } from "../../ui/heading";

export function LipaBidhaaPageHeader() {
  const currentStep = useLipaBidhaaStore((state) => state.currentStep);

  if (currentStep >= 4) return null;

  return (
    <Headers
      name="Lipa Bidhaa"
      subtitle="Send direct payments to suppliers and utility providers"
    />
  );
}
